module.exports = __webpack_public_path__ + "media/images/bnr_header_newplan_80off_sp-2061e335a253d25587e1318bfa5ec57f.jpg";